import {
  OnboardingV1ManagedDataWarehouseProvisioningState as ProvisioningState,
  useAccountMode,
} from '@spotify/confidence-graphql';

import { useConfidenceCloudProvisioning } from '../useConfidenceCloudProvisioning';
import { useIsConfidenceCloud } from '../useIsConfidenceCloud';

export const useConfidenceCloudStatus = (): {
  loading: boolean;
  confidenceCloudFlagEnabled: boolean;
  isConfidenceCloud: boolean;
  isProvisioning: boolean;
} => {
  const { loading, confidenceCloudFlagEnabled, isConfidenceCloud } =
    useIsConfidenceCloud();
  const { hasCustomerWarehouse } = useAccountMode();

  const { loading: provisioningLoading, state } =
    useConfidenceCloudProvisioning({
      skip: isConfidenceCloud || hasCustomerWarehouse,
    });

  const isProvisioning =
    state === ProvisioningState.Creating || state === ProvisioningState.Failed;
  const provisioningStarted =
    isProvisioning || state === ProvisioningState.Active;

  return {
    loading: loading || provisioningLoading,
    confidenceCloudFlagEnabled,
    isConfidenceCloud:
      isConfidenceCloud || (provisioningStarted && !hasCustomerWarehouse),
    isProvisioning,
  };
};
